var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('free-inputtable-object-menu',{attrs:{"source":_vm.source,"unselectedButtonConfiguration":_vm.unselectedButtonConfiguration,"is-input-method-selectable":_vm.source.editingSource.isInputableFromScreen && _vm.isInputMethodSelectable}})}
var staticRenderFns = []

export { render, staticRenderFns }